import { createFocusOutlineStyle, __resetStyles, __styles, mergeClasses, tokens, shorthands } from '@fluentui/react-components';
export const userMessageClassNames = {
  root: 'fai-UserMessage',
  accessibleHeading: 'fai-UserMessage__accessibleHeading'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {
    qb2dma: "f1locze1",
    qhf8xq: "f10pi13n",
    Brovlpu: "ftqa4ok",
    B486eqv: "f2hkw1w",
    B8q5s1w: "f8hki3x",
    Bci5o5g: ["f1d2448m", "ffh67wi"],
    n8qw10: "f1bjia2o",
    Bdrgwmp: ["ffh67wi", "f1d2448m"],
    Bm4h7ae: "f15bsgw9",
    B7ys5i9: "f14e48fq",
    Busjfv9: "f18yb2kv",
    Bhk32uz: "fd6o370",
    Bf4ptjt: "fh1cnn4",
    kclons: ["fy7oxxb", "f184ne2d"],
    Bhdgwq3: "fpukqih",
    Blkhhs4: ["f184ne2d", "fy7oxxb"],
    Bqtpl0w: "frrh606",
    clg4pj: ["f1v5zibi", "fo2hd23"],
    hgwjuy: "ful5kiu",
    Bonggc9: ["fo2hd23", "f1v5zibi"],
    B1tsrr9: ["f1jqcqds", "ftffrms"],
    Dah5zi: ["ftffrms", "f1jqcqds"],
    Bkh64rk: ["f2e7qr6", "fsr1zz6"],
    qqdqy8: ["fsr1zz6", "f2e7qr6"],
    B6dhp37: "f1dvezut",
    i03rao: ["fd0oaoj", "f1cwg4i8"],
    Boxcth7: "fjvm52t",
    Bsom6fd: ["f1cwg4i8", "fd0oaoj"],
    J0r882: "f57olzd",
    Bule8hv: ["f4stah7", "fs1por5"],
    Bjwuhne: "f480a47",
    Ghsupd: ["fs1por5", "f4stah7"],
    z8tnut: "f1kwiid1",
    z189sj: ["fjodcmx", "fhx4nu"],
    Byoj8tv: "f5b47ha",
    uwmqm3: ["fhx4nu", "fjodcmx"],
    De3pzq: "f16xkysk",
    Bbmb7ep: ["fnivh3a", "fc7yr5o"],
    Beyfa6y: ["fc7yr5o", "fnivh3a"],
    B7oj6ja: ["f1el4m67", "f8yange"],
    Btl43ni: ["f8yange", "f1el4m67"],
    Bpd4iqm: "fpvhumw",
    oeaueh: "f1yog68k",
    Bw0xxkn: "f13sgyd8"
  }
}, {
  d: [".f1locze1{align-self:end;}", ".f10pi13n{position:relative;}", ".f8hki3x[data-fui-focus-visible]{border-top-color:transparent;}", ".f1d2448m[data-fui-focus-visible]{border-right-color:transparent;}", ".ffh67wi[data-fui-focus-visible]{border-left-color:transparent;}", ".f1bjia2o[data-fui-focus-visible]{border-bottom-color:transparent;}", ".f15bsgw9[data-fui-focus-visible]::after{content:\"\";}", ".f14e48fq[data-fui-focus-visible]::after{position:absolute;}", ".f18yb2kv[data-fui-focus-visible]::after{pointer-events:none;}", ".fd6o370[data-fui-focus-visible]::after{z-index:1;}", ".fh1cnn4[data-fui-focus-visible]::after{border-top-style:solid;}", ".fy7oxxb[data-fui-focus-visible]::after{border-right-style:solid;}", ".f184ne2d[data-fui-focus-visible]::after{border-left-style:solid;}", ".fpukqih[data-fui-focus-visible]::after{border-bottom-style:solid;}", ".frrh606[data-fui-focus-visible]::after{border-top-width:2px;}", ".f1v5zibi[data-fui-focus-visible]::after{border-right-width:2px;}", ".fo2hd23[data-fui-focus-visible]::after{border-left-width:2px;}", ".ful5kiu[data-fui-focus-visible]::after{border-bottom-width:2px;}", ".f1jqcqds[data-fui-focus-visible]::after{border-bottom-right-radius:var(--borderRadiusMedium);}", ".ftffrms[data-fui-focus-visible]::after{border-bottom-left-radius:var(--borderRadiusMedium);}", ".f2e7qr6[data-fui-focus-visible]::after{border-top-right-radius:var(--borderRadiusMedium);}", ".fsr1zz6[data-fui-focus-visible]::after{border-top-left-radius:var(--borderRadiusMedium);}", ".f1dvezut[data-fui-focus-visible]::after{border-top-color:var(--colorStrokeFocus2);}", ".fd0oaoj[data-fui-focus-visible]::after{border-right-color:var(--colorStrokeFocus2);}", ".f1cwg4i8[data-fui-focus-visible]::after{border-left-color:var(--colorStrokeFocus2);}", ".fjvm52t[data-fui-focus-visible]::after{border-bottom-color:var(--colorStrokeFocus2);}", ".f57olzd[data-fui-focus-visible]::after{top:calc(2px * -1);}", ".f4stah7[data-fui-focus-visible]::after{right:calc(2px * -1);}", ".fs1por5[data-fui-focus-visible]::after{left:calc(2px * -1);}", ".f480a47[data-fui-focus-visible]::after{bottom:calc(2px * -1);}", ".f1kwiid1{padding-top:var(--spacingVerticalS);}", ".fjodcmx{padding-right:var(--spacingHorizontalL);}", ".fhx4nu{padding-left:var(--spacingHorizontalL);}", ".f5b47ha{padding-bottom:var(--spacingVerticalS);}", ".f16xkysk{background-color:var(--colorBrandBackground2);}", ".fnivh3a{border-bottom-right-radius:var(--borderRadiusXLarge);}", ".fc7yr5o{border-bottom-left-radius:var(--borderRadiusXLarge);}", ".f1el4m67{border-top-right-radius:var(--borderRadiusXLarge);}", ".f8yange{border-top-left-radius:var(--borderRadiusXLarge);}", ".fpvhumw{outline-width:1px;}", ".f1yog68k{outline-style:solid;}", ".f13sgyd8{outline-color:var(--colorTransparentStroke);}"],
  f: [".ftqa4ok:focus{outline-style:none;}"],
  i: [".f2hkw1w:focus-visible{outline-style:none;}"]
});
/**
 * Styles for the hidden heading slot
 */
const useHeadingStyles = __resetStyles("rhgro0h", null, [".rhgro0h{clip:rect(0px, 0px, 0px, 0px);height:1px;margin:-1px;width:1px;position:absolute;overflow:hidden;white-space:nowrap;}"]);
/**
 * Apply styling to the UserMessage slots based on the state
 */
export const useUserMessageStyles_unstable = state => {
  const styles = useStyles();
  const headingStyles = useHeadingStyles();
  state.root.className = mergeClasses(userMessageClassNames.root, styles.root, state.root.className);
  if (state.accessibleHeading) {
    state.accessibleHeading.className = mergeClasses(userMessageClassNames.accessibleHeading, headingStyles, state.accessibleHeading.className);
  }
  return state;
};
//# sourceMappingURL=useUserMessageStyles.js.map